// use this key with queries that depends on auth user
// it will allow us to clear all queries when user logout
// NOTE: moved in separate file to prevent error: using var before initialization, when used in other files
export const AUTH_USER_QUERY_KEY = 'authUser';

export const SESSION_QUERY_KEY = 'session';

export const AUTH_USER_INVALIDATION_QUERY_KEY = 'authUserInvalidation';
